var map = {
	"./add.svg": 201,
	"./arrowDown.svg": 101,
	"./arrowUp.svg": 102,
	"./br.svg": 202,
	"./camera.svg": 203,
	"./copy.svg": 204,
	"./delete.svg": 205,
	"./done.svg": 206,
	"./en.svg": 207,
	"./es.svg": 208,
	"./faceFrame.svg": 209,
	"./face_overlay.svg": 210,
	"./restart.svg": 211,
	"./settings-white.svg": 212,
	"./success.svg": 213,
	"./take_photo.svg": 214,
	"./translate.svg": 103,
	"./us.svg": 215,
	"./values.svg": 216,
	"./white-camera.svg": 217,
	"./white-check.svg": 218,
	"./white-restart.svg": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;